import React, { memo, useContext } from 'react';

import { ConfigContext } from './formList';

function Header() {
  const { columns = [] } = useContext(ConfigContext);

  const headers = columns.map((col = {}) =>
    col.title ? (
      <div
        key={col.dataIndex}
        className="cell"
        style={{
          width: col.style?.width,
          textAlign: col.style?.['text-align'],
          paddingLeft: col.style?.['padding-left'],
          position: col.style?.position,
          left: col.style?.left,
          zIndex: col.style?.zIndex,
        }}
      >
        {col.title}
      </div>
    ) : null,
  );
  return (
    <div className="dragable-table-form-row dragable-table-form-header">
      {headers}
    </div>
  );
}

export default memo(Header);
